import React from 'react';
import { Pagination } from 'semantic-ui-react';
import connect from 'react-redux/es/connect/connect';
import { changeProjectListPagination, PROJECTS_LIST_LIMIT } from '../data/actions';

const ProjectsPagination = props => {
  const totalPages = Math.ceil(props.total / PROJECTS_LIST_LIMIT);
  const currentPage = props.skip === 0 ? 1 : Math.ceil(props.total / props.skip);

  if (totalPages < 2) {
    return null;
  }

  const pageChangeHandler = (event, data) => {
    props.dispatch(changeProjectListPagination((data.activePage - 1) * PROJECTS_LIST_LIMIT));
  };

  return (
    <Pagination
      defaultActivePage={currentPage}
      totalPages={totalPages}
      onPageChange={pageChangeHandler}
    />
  );
};

export default connect(state => ({
  skip: state.projects.list.skip,
  total: state.projects.list.total
}))(ProjectsPagination);



// WEBPACK FOOTER //
// ./src/scenes/projects/components/ProjectsPagination.js